import React from 'react'
import { FacebookIcon, InstagramIcon, LinkedinIcon, Logo, TwitterIcon, YouTubeIcon } from '../assets'
import "./footer.component.css"
import { Button, Typography } from '@mui/material'
import { ArrowForward } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const FooterSection = () => {

    const navigate = useNavigate();
    const { t } = useTranslation();

    return (
        <div className="footer-container">
            <div className="footer-signup-container">
                <div className="flex flex-dir-col gp-10 aln-items-cnt">
                    <div className="footer-head-text">
                        <span className="head-txt-off-white">{t('footer.signupTitle1')}</span>
                        <span className="head-txt-primary">{t('footer.signupTitle2')}</span>
                    </div>

                    <span style={{ color: 'var(--white)' }}>{t('footer.byTheCommunity')}</span>

                </div>
                <Button
                    variant="contained"
                    sx={{
                        background: '#ff8303',
                        color: '#ffffff',
                        padding: '12px 24px',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        borderRadius: '8px',
                        '&:hover': {
                            background: '#ff8303'
                        }
                    }}
                    onClick={() => window.open("https://services.rokk-api.com", "_blank")}
                >
                    {t('footer.signUp')}
                </Button>
            </div>

            <div className="footer-content">
                <div className="footer-content-logo-socials">
                    <img src={Logo} alt="rokk_logo_compact" />
                    <div className="social-media-icons-container">
                        <li><img src={LinkedinIcon} alt="social_media_icons" /></li>
                        <li onClick={() => window.location.href = "https://www.youtube.com/@ROKKSTREAMING"}><img src={YouTubeIcon} alt="social_media_icons" /></li>
                        <li onClick={() => window.location.href = "https://www.instagram.com/rokkstreaming/"}><img src={InstagramIcon} alt="social_media_icons" /></li>
                        <li><img src={TwitterIcon} alt="social_media_icons" /></li>
                        <li onClick={() => window.location.href = "https://www.facebook.com/rokkstreamingapp"}><img src={FacebookIcon} alt="social_media_icons" /></li>
                    </div>
                </div>

                <div className="footer-nav-links flex jst-con-spc-btw">
                    <div>
                        <li onClick={() => navigate("../")}>{t('footer.home')}</li>
                        <li onClick={() => navigate("../rokk")}>{t('footer.rokkLink')}</li>
                        <li onClick={() => navigate("../pricing")}>{t('footer.plan')}</li>
                        <li onClick={() => navigate("../faq")}>{t('footer.faqLink')}</li>
                        <li onClick={() => navigate("../artist")}>{t('footer.forArtist')}</li>
                    </div>
                    <div>
                        <li onClick={() => window.location.href="https://igg.me/at/rokkapp"}>{t('footer.signIn')}</li>
                        <li onClick={() => window.location.href="https://igg.me/at/rokkapp"}>{t('footer.signUpLink')}</li>
                    </div>
                </div>

                <div className='footer-content-disclaimer'>

                    <Typography sx={{ marginBottom: '10px' }}>{t('footer.legalDisclaimer')}</Typography>
                    <span style={{ color: 'var(--offWhite)' }}>
                        {t('footer.disclaimerText')}
                        <div>
                            {t('footer.disclaimerText2')}
                        </div>
                        {t('footer.disclaimerText3')}
                        {t('footer.disclaimerText4')}
                    </span>
                    <br />
                    <Button
                        className="company-information"
                        sx={{
                            marginTop: '15px',
                            color: 'rgba(255, 255, 255, 0.6)',
                            borderRadius: '30px',
                            padding: '10px 20px',
                            border: '1px solid rgba(255, 255, 255, 0.6)',
                            textTransform: 'none',
                            '&:hover': {
                                color: 'var(--primary)',
                                borderColor: 'var(--primary)'
                            }
                        }}
                        onClick={() => navigate("./company-info")}
                    >
                        {t('footer.companyInformation')}
                        <ArrowForward className="icon" />
                    </Button>
                </div>

                <div className='terms-and-cond flex jst-con-spc-btw'>
                    <div>
                        {t('footer.copyright')}
                    </div>
                    <div>
                        <li onClick={() => navigate("./privacy-policy")}>{t('footer.privacyPolicy')}</li>
                        <li onClick={() => navigate("./terms-of-use")}>{t('footer.termsOfUse')}</li>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FooterSection
